import { render, staticRenderFns } from "./companyReports.vue?vue&type=template&id=1baee22e&scoped=true"
import script from "./companyReports.vue?vue&type=script&lang=js"
export * from "./companyReports.vue?vue&type=script&lang=js"
import style0 from "./companyReports.vue?vue&type=style&index=0&id=1baee22e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baee22e",
  null
  
)

export default component.exports